<template>
  <div class="dhr-production">
    <h2 class="subtitle">{{this.pageTitle}}</h2>
    <div class="dhr-general">
      <h3 class="title">General info</h3>
      <InputDash     
        class="inputFullWidth"
        :label="this.data.type == 'Assembly' ? 'LOT Number' : 'Batch Number'"
        :name="this.data.type == 'Assembly' ? 'LOT Number' : 'Batch Number'"
        :isTextArea="false"
        :key="1"
        placeholder="Auto"
        :isDisabled="true"
      />
      <InputAutocomplete      
        class="inputFullWidth"       
        label="Product REF"
        name="DeviceRef"
        :searchUrl="searchUrl"
        :isTextArea="false"
        placeholder="search ..."
        :isDisabled="false"
        :value="ref"
        :key="2"
        :hasMoreTop="true"
        @selectedItem="gotSelectedProduct"
      />
    </div>
    <div class="btn-back" @click="$emit('gobackStep', true)">
      <BaseIcon name="chevron-left" class="icon margin-right" />
    </div>
    <div class="btn-next" :class="{'disabled': isIncomplete}" @click="!isIncomplete ? comfirmStep() : doNothing()">
      <BaseIcon name="chevron-right" class="icon margin-right" />
    </div>
  </div>
</template>
<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash";
import InputAutocomplete from "@/components/base/InputAutocomplete";

export default {
  components: {
    InputDash,
    InputAutocomplete,
    BaseIcon
  },
  props: {
    data: Object
  },
  data() {
    return {
      isIncomplete: true,
      lot: "",
      ref: "",
      searchUrl: "",
      lotUrl: "",
      pageTitle: ""
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(){

      if(this.data.type == 'Assembly') {
        this.searchUrl = "management/devices/assemblies/"
        this.pageTitle = "What is the ref of your assembly."
      } else if(this.data.type == 'Single') {
        this.searchUrl = "management/devices/single/"
        this.pageTitle = "What is the ref of your single."
      } else if(this.data.type == 'Subpart') {
        this.searchUrl = "management/devices/subparts/"
        this.pageTitle = "What is the ref of your subpart."
      }

      // if(this.data.lot == ""){
      //   this.getLot()
      // } else {
      //   this.lot = this.data.lot
      // }

      if(this.data.ref != ""){
        this.ref = this.data.ref
      }
      if(this.data.deviceID != ""){
        this.deviceID = this.data.deviceID
      }

    },
    getLot(){
      var that = this

      this.$http.get(this.$endpoint + this.lotUrl)
        .then(response => {
          switch(this.data.type) {
            case "Assembly":
              that.lot = response.data.lotnummer
              break;
            default:
              that.lot = response.data.bonnummer
              break;
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
            .dispatch("logout")
            .then(() => this.$router.push("/login"))
            .catch(err => console.log(err));
          } else {
            that.$swal(
              'Oops that went wrong?',
              `Please contact the admin with the following info: ${ error }`,
              'error'
            );
          }
        })
    },
    gotSelectedProduct(val) {
      this.ref = val.name;
      this.devideID = val.deviceID
      this.$emit("receiveData", {page: 'general', ref: val.ref, flow: val.flowID, lot: this.lot, desc: val.desc, deviceID: val.deviceID});
    },
    comfirmStep() {
      this.$emit("finishedStep", true);
    },
    doNothing() {
    }
  },
  watch: {
    ref: function(val) {
      if(this.ref != "") {
        this.isIncomplete = false
      } else {
        this.isIncomplete = true
      }
    },
    data: {
      handler: function() {
        this.getData()
      },
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";
@import "@/style/components/dhrFormProduction.scss";

</style>;
